import React from 'react';

import {useI18n} from '@udemy/i18n';

import styles from './client-side-video-player.module.less';
import {ClientSideVideoPlayer, VideoPlayerLoader} from './client-side-video-player.react-component';

import type {ClientSideVideoPlayerProps} from './client-side-video-player.react-component';

export interface AsyncClientSideVideoPlayerProps
    extends Partial<Omit<ClientSideVideoPlayerProps, 'asset'>> {
    isLoading: boolean;
    asset?: ClientSideVideoPlayerProps['asset'] | null;
    error?: Error | null;
}

/**
 * Async variant of ClientSideVideoPlayer: loading state, error state, or player when asset is ready.
 */
export const AsyncClientSideVideoPlayer = ({
    isLoading,
    asset,
    error,
    ...playerProps
}: AsyncClientSideVideoPlayerProps) => {
    const {gettext} = useI18n();

    if (isLoading) return <VideoPlayerLoader />;

    if (error || !asset) {
        return (
            <div className={styles.container} role="alert">
                <span className={styles['error-message']}>
                    {error?.message ?? gettext('Video unavailable')}
                </span>
            </div>
        );
    }

    return <ClientSideVideoPlayer asset={asset} {...playerProps} />;
};
